import { useState, useCallback } from 'react'
import { COMPARE_TYPES, DISPLAY_MODES } from '../constants'

const parseQuestionId = id => { const num = Number(id); return Number.isInteger(num) ? num : id }

const useCrossStatisticsForm = (initialValues = {}) => {
  const { questionId } = initialValues
  const rawIds = questionId ? [questionId] : initialValues.questionIds || []
  const initialQuestionIds = rawIds.map(parseQuestionId)

  const [formState, setFormState] = useState({
    variableId: initialValues.variableId || '',
    questionIds: initialQuestionIds,
    startDate: initialValues.startDate || null,
    endDate: initialValues.endDate || null,
    displayMode: initialValues.displayMode || DISPLAY_MODES.COUNT,
    compareType: initialValues.compareType || COMPARE_TYPES.SELECTION
  })

  const updateField = useCallback((field, value) => {
    setFormState(prev => ({ ...prev, [field]: value }))
  }, [])

  const setDateRange = useCallback((startDate, endDate) => {
    setFormState(prev => ({ ...prev, startDate, endDate }))
  }, [])

  const switchCompareType = useCallback(compareType => {
    const displayModes = {
      [COMPARE_TYPES.GRADE]: DISPLAY_MODES.AVERAGE_GRADE,
      [COMPARE_TYPES.NUMERIC]: DISPLAY_MODES.COUNT,
      [COMPARE_TYPES.SELECTION]: DISPLAY_MODES.COUNT
    }
    setFormState(prev => ({
      ...prev,
      compareType,
      displayMode: displayModes[compareType] || DISPLAY_MODES.COUNT,
      questionIds: []
    }))
  }, [])

  return { formState, updateField, setDateRange, switchCompareType }
}

export default useCrossStatisticsForm
